import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ReviewAnalysisApiService } from 'src/services/reviewAnalysisApi'
import { ReviewAnalysisDateRange } from 'src/services/reviewAnalysisApi/interfaces/reviewAnalysis.interface'

export const useGetReviewAnalysisFacilityOverviewQuery = (
  campaignId: string,
  facilityId: string,
  range?: ReviewAnalysisDateRange,
  platformId?: string,
  venueName?: string
) =>
  useQuery({
    enabled: !!campaignId && !!facilityId,
    // Tab/date switches change the queryKey; keep showing the previous stats
    // while the scoped refetch is in flight so the page doesn't flicker.
    placeholderData: keepPreviousData,
    queryFn: () =>
      ReviewAnalysisApiService.getFacilityOverview(
        campaignId,
        facilityId,
        range,
        platformId,
        venueName
      ),
    queryKey: [
      QueryKey.GET_REVIEW_ANALYSIS_FACILITY_OVERVIEW,
      campaignId,
      facilityId,
      range?.from ?? '',
      range?.to ?? '',
      platformId ?? '',
      venueName ?? '',
    ],
  })
